import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Outcomevaping() {
  return (
    <section className="outcome_vaping p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="outcomes">
              <StaticImage
                src="../../../images/case-studies/stop-vaping/outcome_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={671}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>Outcomes</h2>
            <p>
              The resulting app that was created, incorporated social aspects to
              keep users motivated and uptake practices to quit vaping. We are
              proud to be an integral part of a community-friendly solution that
              enables the youth to quit vaping and adopt a healthier lifestyle.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Outcomevaping;
